import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

const baseUrl = environment.api_url;

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  homebannerAPI = 'homebanner';
  homeeventsAPI = 'homeevents';
  homequotesAPI = 'homequotes';
  getlibrarydatacountAPI = 'getlibrarydatacount';
  homepptsAPI = 'homeppts';
  homevideosAPI = 'homevideos';
  homesongsAPI = 'homesongs';
  getallvolunteersAPI = 'getallvolunteers';
  allCounterBookNameWiseAPI = 'AllCounterBookNameWise';
  public frontlanguagegetAPI = 'frontgetlanguages';
  public frontbooknameAPI = 'frontgetbookname';
  public frontauthornameAPI = 'frontgetauthorname';
  public frontpublishernameAPI = 'frontgetpublisername';
  public frontbooktopicAPI = 'frontgettopicname';
  frontgetpopularbooksdataAPI = 'frontgetpopularbooksdata';
  frontgetbhandarlistAPI = 'frontgetbhandarlist';
  frontgetjainsiteAPI = 'frontgetjainsite';
  frontgettipsAPI = 'frontgettips';
  frontgetpdflistAPI = 'frontgetpdflist';
  frontgetbooksearchAPI = 'frontgetbooksearch';
  frontgetbookinfowithbhandarAPI = 'frontgetbookinfowithbhandar';
  frontgetbhandarmasterAPI = 'frontgetbhandarmaster';
  getallarticlesAPI = 'frontgetarticaldata';
  frontgetpptAPI = 'frontgetppt';
  frontgetvideoAPI = 'frontgetvideo';
  frontgetalbumAPI = 'frontgetalbum';
  frontgetsongsAPI = 'frontgetsongs';
  frontgetgallerybyeventidAPI = 'frontgetgallerybyeventid';
  frontgeteventsAPI = 'frontgetevents';
  getpublishersAPI = 'frontgetpublishercatalogues';
  frontgetbooksearchbymasteridAPI = 'frontgetbooksearchbymasterid';
  frontgetbooksearchbytypeAPI = 'frontgetbooksearchbytype';
  frontgetgallerydataAPI = 'frontgetgallerydata';
  frontgetbhandarlistbybookidAPI = 'frontgetbhandarlistbybookid'
  contactusAPI = 'frontsubmitcontactlead';
  volunteerAPI = 'frontsubmitvolunteerslead';
  frontgetbookinfowithbhandaridAPI = 'frontgetbookinfowithbhandarid';
  frontsubmitbookinqueryleadAPI = 'frontsubmitbookinquerylead';
  frontgetquestionpaperAPI = 'frontgetquestionpaper';
  searchallmenuscriptsfrontendAPI = 'searchallmenuscriptsfrontend';
  frontendmenuscriptByIdAPI = 'frontendmenuscriptById';
  frontsubmitmenuscriptinqueryleadAPI = 'frontsubmitmenuscriptinquerylead';
  forgotpasswordtenantusersAPI = 'forgotpasswordtenantusers';
  bhandarregistrationsexportAPI = 'bhandarregistrationsexport';
  bhandarmastersexportAPI = 'bhandarmastersexport';
  bookpublishersexportAPI = 'bookpublishersexport';
  getallthemesettingsAPI = 'getallthemesettings';
  frontgetbookinfowithbhandardataAPI = 'frontgetbookinfowithbhandardata';
  getallfieldsearchfrontendAPI = 'getallfieldsearchfrontend';
  frontgetbooksearchbymasteridwithoutpaginationAPI = 'frontgetbooksearchbymasteridwithoutpagination';
  getbooksearchbytypewithoutpaginationAPI = 'getbooksearchbytypewithoutpagination';
  book_search_data_home = new BehaviorSubject<any>({});

  constructor(private http: HttpClient, private router: Router) { }

  public getHomeBannerList() {
    return this.http.get<any[]>(`${baseUrl}${this.homebannerAPI}`)
  }

  public getEventList() {
    return this.http.get<any[]>(`${baseUrl}${this.homeeventsAPI}`)
  }

  public getQuotesList() {
    return this.http.get<any[]>(`${baseUrl}${this.homequotesAPI}`)
  }

  public getPPTList() {
    return this.http.get<any[]>(`${baseUrl}${this.homepptsAPI}`)
  }

  public getSongsList() {
    return this.http.get<any[]>(`${baseUrl}${this.homesongsAPI}`)
  }

  public getListsCount() {
    return this.http.get<any[]>(`${baseUrl}${this.getlibrarydatacountAPI}`)
  }

  public getVideoList() {
    return this.http.get<any[]>(`${baseUrl}${this.homevideosAPI}`)
  }

  public getVolunteerList() {
    return this.http.get<any[]>(`${baseUrl}${this.getallvolunteersAPI}`)
  }

  public getBookList(listtype) {
    return this.http.post<any[]>(`${baseUrl}${this.allCounterBookNameWiseAPI}`, listtype)
  }

  public getLanguagesList() {
    return this.http.get<any[]>(`${baseUrl}${this.frontlanguagegetAPI}`)
  }

  public getBookNameList(bookname) {
    return this.http.post<any[]>(`${baseUrl}${this.frontbooknameAPI}`, bookname)
  }

  public getAuthorNameList(authorname) {
    return this.http.post<any[]>(`${baseUrl}${this.frontauthornameAPI}`, authorname)
  }

  public getPublisherNameList(publishername) {
    return this.http.post<any[]>(`${baseUrl}${this.frontpublishernameAPI}`, publishername)
  }

  public getBookTopicList(booktopic) {
    return this.http.post<any[]>(`${baseUrl}${this.frontbooktopicAPI}`, booktopic)
  }

  public getJainSiteList() {
    return this.http.get<any[]>(`${baseUrl}${this.frontgetjainsiteAPI}`)
  }

  public getTipsList() {
    return this.http.get<any[]>(`${baseUrl}${this.frontgettipsAPI}`)
  }

  public getPdfList(pdfData, pageId) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetpdflistAPI}?page=${pageId}`, pdfData)
  }

  public getPopularBookList() {
    return this.http.get<any[]>(`${baseUrl}${this.frontgetpopularbooksdataAPI}`)
  }

  public getBhandarListFront(bhandarObj, page) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbhandarlistAPI}?page=${page}`, bhandarObj)
  }

  public getbooksByBhandarId(bhandarid, page) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbooksearchAPI}?page=${page}`, bhandarid)
  }

  public getbooksByBookTypeId(bhandarid, page) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbooksearchbymasteridAPI}?page=${page}`, bhandarid)
  }

  public getbooksByBookTopicId(bhandarid, page) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbooksearchbytypeAPI}?page=${page}`, bhandarid)
  }

  public getBookSearchList(searchval) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbooksearchAPI}`, searchval)
  }

  public getBookInfoList(booktopic) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbookinfowithbhandarAPI}`, booktopic)
  }

  public getbhandarMasterLst(bhandarObj, page) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbhandarmasterAPI}?page=${page}`, bhandarObj)
  }

  public getArticleList() {
    return this.http.get<any[]>(`${baseUrl}${this.getallarticlesAPI}`)
  }

  public getPublishersFront(bhandarObj, page) {
    return this.http.post<any[]>(`${baseUrl}${this.getpublishersAPI}?page=${page}`, bhandarObj)
  }

  public getAllEventsList() {
    return this.http.get<any[]>(`${baseUrl}${this.frontgeteventsAPI}`)
  }

  public getGalleryFromEventsList(eventid) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetgallerybyeventidAPI}`, eventid)
  }

  public getAllSongsList() {
    return this.http.get<any[]>(`${baseUrl}${this.frontgetsongsAPI}`)
  }

  public getAllAlbumsList() {
    return this.http.get<any[]>(`${baseUrl}${this.frontgetalbumAPI}`)
  }

  public getAllVideosList() {
    return this.http.get<any[]>(`${baseUrl}${this.frontgetvideoAPI}`)
  }

  public getAllPptList() {
    return this.http.get<any[]>(`${baseUrl}${this.frontgetpptAPI}`)
  }

  public getAllPdfList() {
    return this.http.get<any[]>(`${baseUrl}${this.frontgetquestionpaperAPI}`)
  }

  public getGalleryData() {
    return this.http.get<any[]>(`${baseUrl}${this.frontgetgallerydataAPI}`)
  }

  public getBhandarListFromBookId(bhandarObj, page) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbhandarlistbybookidAPI}?page=${page}`, bhandarObj)
  }

  public contactUsForm(formdetails) {
    return this.http.post<any[]>(`${baseUrl}${this.contactusAPI}`, formdetails)
  }

  public volunteerForm(formdetails) {
    return this.http.post<any[]>(`${baseUrl}${this.volunteerAPI}`, formdetails)
  }

  public getBookDetailsFromIds(bookdata) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbookinfowithbhandaridAPI}`, bookdata)
  }

  public requestBook(bookdata) {
    return this.http.post<any[]>(`${baseUrl}${this.frontsubmitbookinqueryleadAPI}`, bookdata)
  }

  public getManuscriptList(manuscriptdata, page) {
    return this.http.post<any[]>(`${baseUrl}${this.searchallmenuscriptsfrontendAPI}?page=${page}`, manuscriptdata)
  }

  public getManuscriptDetailsFromIds(manuscriptid) {
    return this.http.get<any[]>(`${baseUrl}${this.frontendmenuscriptByIdAPI}/${manuscriptid}`)
  }

  public requestManuscript(manuscriptdata) {
    return this.http.post<any[]>(`${baseUrl}${this.frontsubmitmenuscriptinqueryleadAPI}`, manuscriptdata)
  }

  public forgotpasswordtenantusers(email) {
    return this.http.post<any[]>(`${baseUrl}${this.forgotpasswordtenantusersAPI}`, email)
  }

  public getBooksInBhandarDataFront(data) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbookinfowithbhandardataAPI}`, data)
  }
  
  public bhandarregistrationsexport() {
    return this.http.get<any[]>(`${baseUrl}${this.bhandarregistrationsexportAPI}`)
  }
  
  public bhandarmastersexport(data) {
    return this.http.post<any[]>(`${baseUrl}${this.bhandarmastersexportAPI}`,data)
  }
  
  public bookpublishersexport() {
    return this.http.get<any[]>(`${baseUrl}${this.bookpublishersexportAPI}`)
  }
  
  public getThemeSettings() {
    return this.http.get<any[]>(`${baseUrl}${this.getallthemesettingsAPI}`)
  }
  
  public filterSuggestionList(data) {
    return this.http.post<any[]>(`${baseUrl}${this.getallfieldsearchfrontendAPI}`, data)
  }
  
  public getAllBhandarListMasterTypeDataFilter(data) {
    return this.http.post<any[]>(`${baseUrl}${this.frontgetbooksearchbymasteridwithoutpaginationAPI}`, data)
  }
  
  public getAllBhandarListDataFilter(data) {
    return this.http.post<any[]>(`${baseUrl}${this.getbooksearchbytypewithoutpaginationAPI}`, data)
  }

  public getAllFrontBookStores() {
    return this.http.get<any[]>(`${baseUrl}getallfrontbookstores`)
  }
  public generateSessionTokens() {
    return this.http.get<any[]>(`${baseUrl}generatesessiontokens`)
  }
  public getAllFrontBookStoresBooksPublishers() {
    return this.http.get<any[]>(`${baseUrl}getallfrontbookstoresbookspublishers`)
  }
  public getAllFrontBookStoresBySearch(data,page) {
    return this.http.post<any[]>(`${baseUrl}getallfrontbookstoresbysearch?page=${page}`, data)
  }
  public addBookInCart(data) {
    return this.http.post<any[]>(`${baseUrl}addbookincart`, data)
  }
  public updateBookInCart(data) {
    return this.http.post<any[]>(`${baseUrl}updatebooksincartquantity`, data)
  }
  public getCartBooksFrontBookStore(data) {
    return this.http.post<any[]>(`${baseUrl}getcartbooksfrontbookstore`, data)
  }
  public deleteBookFromCart(id) {
    return this.http.get<any[]>(`${baseUrl}deletebookfromcart/${id}`)
  }
  public placeOrder(data) {
    return this.http.post<any[]>(`${baseUrl}checkoutfromcart`, data)
  }
  public getFrontUserByMobile(data) {
    return this.http.post<any[]>(`${baseUrl}getfrontuserbymobile`, data)
  }
  public getAllExternalSource() {
    return this.http.get<any[]>(`${baseUrl}listexternalsource`)
  }

}
